<div class="manage">
    <div class="kt-portlet__head ">
        <h3 class="popup_head"><span
                [ngClass]="{'clr_green': data.mode == 'Success', 'clr_red': data.mode == 'Error', 'clr_orange': data.mode == 'Warning' }">{{toasterTitle}} - {{code}}</span>
        </h3>
        <button mat-icon-button aria-label="close dialog" mat-dialog-close>
            <i class="fa fa-times" style="font-size:13px;float:right; cursor: pointer;"></i>
        </button>
    </div>
    <div class="divider">
        <mat-divider></mat-divider>
    </div>
    <div class="d_content ">
        <p style="font-size: 14px;"> {{contentMsg}} </p>
    </div>
</div>


<div class="row">
    <div class="col-sm-4">
    </div>
    <div class="col-sm-4">
        <button mat-raised-button class="savebutton del-pad" (click)="confirmDelete()">{{ok_btn ? ok_btn : 'OK'}}</button>
    </div>
    <div class="col-sm-4" style="text-align:right;">

    </div>
</div>